import { spacing } from '@nerdwallet/base-styles/variables';

export const backgroundSizes = [
  { label: 'Contain', value: 'contain' },
  { label: 'Cover', value: 'cover' },
  { label: 'Auto', value: 'auto' },
];

const moveArrayItemPosition = (array, oldIndex, newIndex) => {
  let resultIndex = newIndex;
  if (newIndex >= array.length) {
    resultIndex = array.length - 1;
  }
  array.splice(resultIndex, 0, array.splice(oldIndex, 1)[0]);
  return array;
};

// Parsing base-styles spacing values to array and removing "--wide" entries
const mapCurrencySpacingSizes = Array.from(
  new Map(Object.entries(spacing)),
  ([key, value]) => ({ label: key, value })
).filter((item) => !item.label.includes('--wide'));

// Let's use "moveArrayItemPosition" to prevent the "3-half" size from being in the last position
const currencySpacingSizes = moveArrayItemPosition(
  mapCurrencySpacingSizes,
  6,
  4
);

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

// Once Top, Left, Right and bottom will be the same for both padding and margin
// let's avoid repeatable code and use this builder to handle this.
export const buildSpacingInputs = (
  inputComponent,
  fielName,
  fieldList = [],
  extraLabel = '',
  isSelectInput
) => {
  const help = {
    help: 'Defaults to "0"',
  };
  if (isSelectInput) {
    return fieldList.map((input) =>
      inputComponent(
        `${fielName}.${input}`,
        `${capitalize(input)}`,
        [...currencySpacingSizes, { label: 'Auto', value: 'auto' }],
        help
      )
    );
  }
  return fieldList.map((input) =>
    inputComponent(
      `${fielName}.${input}`,
      `${capitalize(input)} ${extraLabel}`,
      help
    )
  );
};
